import React from 'react';
import PropTypes from 'prop-types';
import { isSet } from '../../../utils/commonUtils';

const NewTextArea = (props) => {
  const {
    className,
    placeholder,
    value,
    style,
    disabled,
    readOnly,
    name,
    required,
    onKeyPress,
    onBlur,
    ref,
    rows,
    label
  } = props;

  const { changeHandler } = props;

  const onChangeHandler = (e) => {
    changeHandler(e.target.value, {e});
  };

  return (
     <div className="form-group mb-0">
      {label && <label className="form-label">{label}</label>}
    <textarea
      className={className}
      name={name}
      id={isSet(props.id,name)}
      placeholder={placeholder}
      value={value}
      style={{...style}}      
      disabled={disabled}
      readOnly={readOnly}
      onChange={(e) => onChangeHandler(e)}
      onKeyDown={onKeyPress}
      required={required}
      onBlur={onBlur}
      ref={ref}
      rows={rows}
    />
    </div>
  );
};

NewTextArea.defaultProps = {
  className: 'form-control',
  placeholder: '',
  disabled:false,
  readOnly:false,
  value: '',
  style: {},
  required:false,
  onBlur:()=>{},
  ref:null,
  rows:""
};

NewTextArea.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  changeHandler: PropTypes.func.isRequired,
};

export default NewTextArea;
